module.exports = __webpack_public_path__ + "static/media/maintenanceTasks.4070a4fe.svg";